<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<p class="center ">Text copyright © 1996 by Jane Yolen</p>
<p class="center spaceabove1">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<p class="center spaceabove1">
<em>Acknowledgment</em>
</p>
<p class="center ">This book is based on the short story “The Wild Child” from the collection <em>Merlin’s Booke,</em> but has been significantly expanded and refocused.</p>
<p class="center spaceabove1">The Library of Congress has cataloged the print edition as follows:</p>
<p class="center ">Yolen, Jane.<br/>
Passager/Jane Yolen.—1st ed.<br/>
p. cm.</p>
<p class="center ">Summary: A foundling rediscovers his identity through the help of the falconer who adopts him.</p>
<p class="center ">ISBN 0-15-200391-6</p>
<p class="center ">1. Merlin (Legendary character)—Juvenile fiction. [1. Merlin (Legendary character)—Fiction. 2. Feral children—Fiction. 3. Falconry—Fiction.] I. Title.</p>
<p class="center ">PZ7.Y78Pas 1996<br/>
[Fic]—dc20 94-27101</p>
<p class="center spaceabove1">eISBN 978-0-544-20120-0<br/>
v2.0421</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?12f1762b